import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const flipperLendersApi = createApi({
  reducerPath: "flipperLendersApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FlipperLender"],
  endpoints: (build) => ({
    getAllFlipperLenders: build.query({
      query: ({ lenderType, status, limit = 500 } = {}) => ({
        url: "/flipper/lenders",
        method: "GET",
        params: { lenderType, status, limit },
      }),
      providesTags: ["FlipperLender"],
    }),
    createFlipperLender: build.mutation({
      query: (data) => ({ url: "/flipper/lenders", method: "POST", body: data }),
      invalidatesTags: ["FlipperLender"],
    }),
    updateFlipperLender: build.mutation({
      query: ({ id, ...data }) => ({ url: `/flipper/lenders/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["FlipperLender"],
    }),
    deleteFlipperLender: build.mutation({
      query: (id) => ({ url: `/flipper/lenders/${id}`, method: "DELETE" }),
      invalidatesTags: ["FlipperLender"],
    }),
  }),
});

export const {
  useGetAllFlipperLendersQuery,
  useCreateFlipperLenderMutation,
  useUpdateFlipperLenderMutation,
  useDeleteFlipperLenderMutation,
} = flipperLendersApi;
